import {
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Stack,
  Text
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from '../../../components/common/Loading';


import { useContext, useState } from "react";
import SurveyService from "../../../services/admin/survey.service";
import TemplateCodeContextProvider, { TemplateCodeContext } from "../../contextProvider/templateCodeProvider";
import Adminroutes from "../routes";

const TemplateItem = ({ each, reducedObj}: any) => {
  const [hideView, sethideView] = useState(true);
  const [questionLoading, setQuestionLoading] = useState(true);
  const [templateQuestions, setTemplateQuestions] = useState<any>([]);
  const navigate = useNavigate();
  const { templateCode1, setTemplateCode1 } = useContext(TemplateCodeContext);
  const { templateCode2, setTemplateCode2 } = useContext(TemplateCodeContext);
  const { templateCode3, setTemplateCode3 } = useContext(TemplateCodeContext);
  const { templateCode4, setTemplateCode4 } = useContext(TemplateCodeContext);
  const params = useParams();
  const tab_index:any = params.tab_index;


  
  const handleView = async (each: string) => {
    sethideView(false);
    const arrIds = reducedObj[each];
    const promises = arrIds.map(async(id: string) => {
    const res = await SurveyService.getSurveyQuestion(id);
    return res.data;
   })
   const questions = await Promise.all(promises)
    setTemplateQuestions(questions);
    if (templateQuestions) 
    setQuestionLoading(false);
  };

  const handleHide = () => {
    sethideView(true);
  };


  const handleUse = (each:any) => {
    sessionStorage.setItem("tabIndex", tab_index);
    switch (tab_index) {
      case "0":
        setTemplateCode1(each);
        navigate(Adminroutes.UseTemplate);
        break;
      case "1":
        setTemplateCode2(each);
        navigate(Adminroutes.UseTemplate);
        break;
      case "2":
        setTemplateCode3(each);
        navigate(Adminroutes.UseTemplate);
        break;
      case "3":
        setTemplateCode4(each);
        navigate(Adminroutes.UseTemplate);
        break;
      default:
        break;
    }
  };

  
  return (
    <TemplateCodeContextProvider>
    <Box width="85%">
      <HStack
        width="100%"
        borderColor="#9E9E9E"
        borderWidth="0.3px"
        height="4rem"
        justifyContent="space-between"
        padding="0.5rem 1.5rem"
      >
        <Text>Survey Template {each}</Text>
        <HStack gap="1rem">
          <Button
            borderRadius="4px"
            fontSize="13px"
            fontWeight="600"
            onClick={() => handleView(each)}
            hidden={!hideView}
          >
            View
          </Button>
          <Button
            borderRadius="4px"
            fontSize="13px"
            fontWeight="600"
            onClick={handleHide}
            hidden={hideView}
          >
            Hide
          </Button>
          <Button
            colorScheme="red"
            borderRadius="4px"
            fontSize="13px"
            fontWeight="600"
            onClick={() => handleUse(each)}
          >
            Use
          </Button>
        </HStack>
      </HStack>
      <Box height="32rem" hidden={hideView} overflowY="scroll" marginY="1.2rem">
        {questionLoading ? (
          <Loading />
        ) : (
          templateQuestions.map((each: any, index: any) => (
            <Box
              key={index}
              width="85%"
              height="auto"
              m="3rem auto"
              borderColor="#9E9E9E"
              borderRadius="8px"
              borderWidth="0.3px"
              px="2.5rem"
              py="1.4rem"
            >
              <HStack spacing="8px">
                <Text>{index + 1}.</Text>
                <Text
                  width="100%"
                  fontWeight="500"
                  fontSize="16px"
                  lineHeight="22px"
                >
                  {each.question}
                </Text>
              </HStack>
              <Flex justifyContent="space-between" mt="1.6rem">
                <Stack spacing="14px">
                  <HStack fontSize="14px">
                    <Text>1.</Text>
                    <Text>{each.label1}</Text>
                  </HStack>
                  <HStack fontSize="14px">
                    <Text>5.</Text>
                    <Text>{each.label2}</Text>
                  </HStack>
                </Stack>
              </Flex>
              <Divider mt="1.6rem" mb="1.6rem"/>
            </Box>
          ))
        )}
      </Box>
    </Box>
    </TemplateCodeContextProvider>
  );
};

export default TemplateItem;
